/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['assets/js/modules/pricing/pricingModel'], function(PricingModel) {
    return PricingModel.extend({
        defaults: {
            strategy: 'free'
        },
        /**
         * @param {Object} context
         * @returns {number}
         */
        getPrice: function(context) {
            return 0;
        },

        toString: function(context) {
            return 'free';
        }
    });
});
